import { useTenantStore } from '@/stores/tenantStore'
import type { components } from '@/types/api/v1'
import { $api, type InferResponse } from '../../typedClient'

// Types inferred from OpenAPI schema
export type UnifiedHistoryResponse = InferResponse<
  '/crossroads/order/change/history',
  'post'
>
export type UnifiedHistoryItem = UnifiedHistoryResponse[number]

// Individual item types for type narrowing
export type OrderChangeHistoryItem = Extract<
  UnifiedHistoryItem,
  { item_type: 'order_change' }
>
export type BOLHistoryItem = Extract<UnifiedHistoryItem, { item_type: 'bol' }>
export type DropHistoryItem = Extract<UnifiedHistoryItem, { item_type: 'drop' }>
export type OrderEventHistoryItem = Extract<
  UnifiedHistoryItem,
  { item_type: 'order_event' }
>

// Legacy alias for backward compatibility
export type OrderChangeHistoryResponse = UnifiedHistoryResponse

export type ChangeSnapshot = components['schemas']['ChangeSnapshot-Output']

// Type guards for discriminated union
export function isOrderChange(
  item: UnifiedHistoryItem,
): item is OrderChangeHistoryItem {
  return item.item_type === 'order_change'
}

export function isBOL(item: UnifiedHistoryItem): item is BOLHistoryItem {
  return item.item_type === 'bol'
}

export function isDrop(item: UnifiedHistoryItem): item is DropHistoryItem {
  return item.item_type === 'drop'
}

export function isOrderEvent(
  item: UnifiedHistoryItem,
): item is OrderEventHistoryItem {
  return item.item_type === 'order_event'
}

export function useOrderHistory(orderNumber: string | null) {
  const { selectedTenant } = useTenantStore()
  const shouldFetch = !!orderNumber && !!selectedTenant?.name

  return $api.useQuery(
    'post',
    '/crossroads/order/change/history',
    {
      body: {
        order_numbers: orderNumber ? [orderNumber] : [],
      },
    },
    {
      enabled: shouldFetch,
    },
  )
}
